<template>
  <v-pagination :model-value="activePage"
                :disabled="disabled"
                :total-visible="4"
                :length="lengthPagination">
      <template v-slot:item="item">
        <button-square
            @click="changeModelPage(item.page)"
            :disabled="item.props.disabled"
            :active="item.isActive">
          {{ item.page }}
        </button-square>
      </template>
  </v-pagination>
</template>

<script>
import ButtonSquare from "@/components/shared/buttons/ButtonSquare.vue";

export default {
  name: "Pagination",
  components: {ButtonSquare},
  props: {
    lengthPagination: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activePage: {
      type: Number,
      required: true
    }
  },
  methods: {
    changeModelPage(page) {
      this.$emit('changePage', Number(page))
    }
  },
}
</script>

<style scoped>

</style>